<template>
  <v-container fluid id="fcreate">
    <Breadcrumbs/>
    <h1 class="mb-1 text-h2">
      Редактирование акции
    </h1>
    <v-row>
      <v-form v-model="valid" ref="form">
        <v-container fluid>
          <v-row>
            <!-- Название -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.name"
                label="Название"
                outlined
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <v-col cols="12" md="7">
              <regions-select-fields
                v-model="data.regions"
                label="Доступно в регионах"
                empty-text="Доступно во всех регионах"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <v-col cols="12" md="7">
              <regions-select-fields
                v-model="data.regionsExclude"
                label="Не доступно в регионах"
                empty-text="Нет исключенных регионов"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Подзаголовок -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.subName"
                label="Заголовок в личном кабинете"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Slug -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.slug"
                label="URL"
                outlined
                required
                :rules="rules.slug"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Цвет фона картинки -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.imgBgrColor"
                label="Цвет фона картинки"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Изображение -->
            <v-col cols="12" md="7">
              <upload-image
                v-model="data.image"
                color="blue"
                label="Загрузить"
              >
                <v-icon
                  left
                  v-text="`mdi-plus`"
                />
                Картинка
              </upload-image>
            </v-col>
            <v-col cols="12" md="7">
              <upload-image
                v-model="data.mobileImage"
                color="blue"
                label="Загрузить фото"
              >
                <v-icon
                  left
                  v-text="`mdi-plus`"
                />
                Мобильная картинка
              </upload-image>
            </v-col>
            <!-- Описание -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.description"
                label="Описание в личном кабинете"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Текст над промокодом -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.textOne"
                label="Текст над промокодом"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Промокод -->
            <v-col cols="12" md="7">
              <v-autocomplete
                v-model="data.promoCodeId"
                :items="orders"
                item-text="name"
                item-value="id"
                label="Промокод"
                clearable
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Текст под промокодом -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.textTwo"
                label="Текст под промокодом"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Тег h1 -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.h1"
                label="H1 (заголовок страницы)"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Мета заголовок -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.metaTitle"
                label="Meta title"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Мета Описание -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.metaDescription"
                label="Meta description"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Дата начала -->
            <v-col cols="12" md="7">
              <v-menu
                v-model="menuBegin"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="computedTimeOnDateFormattedMomentjs"
                    clearable
                    label="Дата начала"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="data.dateBegin = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="data.dateBegin"
                  @change="menuBegin = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- Дата конца -->
            <v-col cols="12" md="7">
              <v-menu
                v-model="menuEnd"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="computedTimeEndDateFormattedMomentjs"
                    clearable
                    label="Дата конца"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="data.dateEnd = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="data.dateEnd"
                  @change="menuEnd = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- Сортировка -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.sortOrder"
                label="Сортировка"
                outlined
                required
                :rules="rules.requiredNumber"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Сохранить -->
            <v-col cols="12" md="7">
              <v-row>
                <v-col md="4">
                  <v-btn
                    block
                    large
                    :loading="loadingForm"
                    :disabled="loadingForm"
                    @click.prevent="$router.push('/promotions')"
                  >
                    Отмена
                  </v-btn>
                </v-col>
                <v-col md="4">
                  <v-btn
                    block
                    large
                    class="mb-2 btm"
                    color="blue"
                    :loading="loadingForm"
                    :disabled="loadingForm"
                    @click.prevent="save(false)"
                  >
                    Применить
                  </v-btn>
                </v-col>
                <v-col md="4">
                  <v-btn
                    block
                    large
                    class="mb-2"
                    color="success"
                    :loading="loadingForm"
                    :disabled="loadingForm"
                    @click.prevent="save"
                  >
                    Сохранить
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Измемнения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  import UploadImage from './../../components/UploadImage'
  import rules from '@/mixins/rules'
  import RegionsSelectFields from '@/components/ui/crud/fields/RegionsSelectField.vue'
  import snackbarMessage from '@/mixins/snackbar-message'

  export default {
    mixins: [rules, snackbarMessage],
    components: { UploadImage, RegionsSelectFields },
    data () {
      return {
        data: {
          promoCodeId: '',
          name: '',
          subName: '',
          slug: '',
          image: '',
          description: '',
          h1: 'h1',
          metaTitle: '',
          metaDescription: '',
          imgBgrColor: '',
          textOne: '',
          textTwo: '',
          dateBegin: '',
          dateEnd: '',
          sortOrder: 0,
          status: true,
          promoCode: null,
          regions: [],
          regionsExclude: [],
        },
        menuBegin: false,
        menuEnd: false,
        valid: false,
        loading: false,
        loadingForm: false,
        snackbar: false,
        snackbarSuccess: false,
      }
    },
    computed: {
      ...mapState('promocodes', ['orders']),
      getId () { return this.$route.params.id },
      computedTimeOnDateFormattedMomentjs () {
        return this.data.dateBegin ? moment(this.data.dateBegin).format('YY-MM-DD') : ''
      },
      computedTimeEndDateFormattedMomentjs () {
        return this.data.dateEnd ? moment(this.data.dateEnd).format('YY-MM-DD') : ''
      },
    },
    async created () {
      try {
        const res = await this.$store.dispatch('promotions/fetchSinglePromotions', this.getId)
        this.data = res.data.data
        this.data.promoCodeId = res.data.data.promoCode ? res.data.data.promoCode.id : null
        this.data.regions = res.data.data.regions.map(item => item.id)
        this.data.regionsExclude = res.data.data.regionsExclude.map(item => item.id)
      } catch (err) { console.error(err) }

      try {
        await this.$store.dispatch('promocodes/fetchPromocodesList', {
          limit: 10000,
          offset: 0,
          page: 0,
        })
      } catch (err) { console.error(err) }
    },
    methods: {
      async save (redirect = true) {
        const validate = await this.$refs.form.validate()

        if (validate) {
          try {
            this.loadingForm = true
            const data = this.data
            data.promoCodeId = this.data.promoCodeId || null

            const res = await this.$store.dispatch('promotions/editPromotions', { data: data, id: this.getId })
            if (redirect) {
              this.$router.push('/promotions')
            }
            this.snackbarSuccess = true
            setTimeout(() => {
              this.snackbarSuccess = false
            }, 3000)
          } catch (e) {
            this.showErrorFromResponse(e)
          }

          this.loadingForm = false
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>
